import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { TimeElapsedService } from 'src/app/shared/services/time-elapsed/time-elapsed.service';

@Component({
  selector: 'htc-time-elapsed',
  templateUrl: './time-elapsed.component.html',
  styleUrls: ['./time-elapsed.component.scss'],
  standalone: false,
})
export class TimeElapsedComponent implements OnInit, OnDestroy {
  time = '00:00';
  private subscription = new Subscription();
  constructor(
    private timeElapsedService: TimeElapsedService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.subscription = this.timeElapsedService.time.subscribe(item => {
      this.time = item;
      this.cdr.markForCheck();
    });
  }

  ngOnDestroy(): void {
    this.timeElapsedService.stopTimer();
    this.subscription.unsubscribe();
  }
}
